import React, { useEffect } from "react";

const PrivacyPolicy = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const stop = (e) => e.stopPropagation();

  return (
    <div
      className="fixed inset-0 z-[1000] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl bg-white rounded-2xl shadow-xl"
        onClick={stop}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">
            Privacy Policy
          </h1>
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100"
          >
            Close
          </button>
        </div>

        {/* Scrollable content */}
        <div className="px-6 py-5 max-h-[70vh] overflow-y-auto">
          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              Introduction
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              Your privacy is important to us. This Privacy Policy outlines how we collect,
              use, and safeguard your personal information when you visit our website.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              Information We Collect
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              We may collect personal information such as your name, email address, and any
              other details you provide when interacting with our website.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              How We Use Your Information
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              Your information is used to improve our services, provide customer support, and
              send updates or promotional materials. We do not sell your data to third parties.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              Cookies and Tracking
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              We use cookies and similar technologies to enhance your browsing experience,
              analyze website traffic, and personalize content. You can manage your cookie
              preferences in your browser settings.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              Security
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              We implement various security measures to protect your personal information.
              However, no method of transmission over the Internet is completely secure.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              Changes to This Privacy Policy
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              We may update this Privacy Policy periodically. Any changes will be posted on
              this page along with an updated revision date.
            </p>
          </section>

          <section className="mb-2">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              Contact Us
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              If you have any questions about this Privacy Policy, please contact us at
              <a href="mailto:privacy@example.com" className="text-emerald-600 hover:underline">
                {" "}privacy@example.com
              </a>.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-5 py-2.5 rounded-xl"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;